module.exports = __webpack_public_path__ + "assets/img/travel-day21.bcd38d98.png";